import { Card, FormControlLabel, Typography, Checkbox, Button } from '@mui/material'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
import DateHora from '../../../../utils/dateHora'
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
// import * as yup from 'yup'; // VALIDACAO
import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../../../services/api';
import ButtonLeft from '../../../../utils/buttonLeft';
import FazerObservacoes from '../../../components/fazerObservacoes.';
import StatusSolicitacoes from '../../../../utils/status/statusSolicitacoes';
import InfoFieldGroup from '../../../../utils/InfoField/InfoFieldGroup';

export default function FichaSolicitacaoImportacao({ solicitacaoImportacao, setRefresh, habiliteThis, setHabiliteThis, admin = false }) {
    const user = useSelector(state => state.account.user);
    const { id } = useParams()
    const dispatch = useDispatch()
    const [action, setAction] = useState('approve')
    const [obs, setObs] = useState('Confirmo que o processo está em conformidade.')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [load, setLoad] = useState(false)
    const [confirmProcesso, setConfirmProcesso] = useState(false)

    const handleApprove = (assunto) => {
        setLoad(true)
        api.patch('/solicitacao-importacao/approve', {
            solicitacaoImportacaoId: id,
            userId: user?._id
        }).then(response => {
            // console.log(response);
            obs && HandleCreateobservacao(assunto);
            setRefresh(response.data);
            dispatch({
                type: 'alert',
                payload: { alert: 'Solicitação aprovada com sucesso.!' },
            });
        }).catch(error => {
            // console.log(error);
            setMessageError(error.response.data.message)
        }).finally(() => setLoad(false))
    }

    async function HandleCreateobservacao(assunto) {
        setLoad(true)
        setMessageError('')
        setMessageSuccess('')

        await api.post('/observacao/create', {
            assunto: assunto,
            descricao: obs ?? 'Confirmo que o processo está em conformidade.',
            userId: user._id,
            estabelecimentoId: solicitacaoImportacao.importador._id
        }).then(res => {
            setLoad(false)
            setMessageSuccess(res.data.msg)

        }).catch(error => {
            setMessageError(error.response.data.message)
            setLoad(false)
        })
    }

    return (
        <Card style={{ padding: 20, position: 'relative' }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <HeaderGestorConfigs
                menu={false}
                configArea={''}
                title={'SOLICITAÇÃO DE IMPORTAÇÃO'}
            />

            {(solicitacaoImportacao?.status === 'Aprovado' && solicitacaoImportacao?.dataAprovacao) &&
                <img src="/img/icones/licenciamentoicon.svg" alt="autor.." width={35} style={{ position: 'absolute', right: 25 }} />
            }
            <InfoFieldGroup
                // submit={submitEdit}
                // data={editDados}
                // handleChange={handleChange}
                // setIsEdit={setIsEdit}
                isEdit={false}
                load={false}
                fields={
                    [
                        { label: 'Estado', value: <StatusSolicitacoes status={solicitacaoImportacao?.status} />, editable: false, },
                        { label: 'ID', value: solicitacaoImportacao?.solicitacaoId, key: 'solicitacaoId', onChange: (v) => 'setEditDados({ ...editDados, solicitacaoId: v.target.value })' },
                        { label: 'Processo', value: solicitacaoImportacao?.numero, key: 'numero', onChange: (v) => 'setEditDados({ ...editDados, numero: v.target.value })' },
                        // { label: 'Factura de Emolumento', value: solicitacaoImportacao?.numFatura, key: 'numFatura', onChange: (v) => 'setEditDados({ ...editDados, numFatura: v.target.value })' },
                        { label: 'País de Origem', value: solicitacaoImportacao?.paisOrigem, key: 'paisOrigem', onChange: (v) => 'setEditDados({ ...editDados, paisOrigem: v.target.value })' },
                        { label: 'Endereço', value: solicitacaoImportacao?.endereco, key: 'endereco', onChange: (v) => 'setEditDados({ ...editDados, endereco: v.target.value })' },
                        { label: 'Fornecedor', value: solicitacaoImportacao?.fornecedorNome, key: 'fornecedorNome', onChange: (v) => 'setEditDados({ ...editDados, fornecedorNome: v.target.value })' },
                        { label: 'Factura Proforma', value: solicitacaoImportacao?.numFaturaPro, key: 'numFaturaPro', onChange: (v) => 'setEditDados({ ...editDados, numFaturaPro: v.target.value })' },
                        { label: 'Data de Solicitação', value: <DateHora date={solicitacaoImportacao.createdAt} />, key: 'createdAt', onChange: (v) => 'setEditDados({ ...editDados, createdAt: v.target.value })' },
                    ]
                } />

            {(solicitacaoImportacao?.status !== 'Aprovado' && habiliteThis) &&
                <>
                    <FazerObservacoes setObs={setObs} obs={obs} titulo={action === 'approve' ? '(caso seja necessário fazer alguma observação)' : '(Descreve os motivos desta reprovação para o utente)'} />
                    <Typography my={2}>
                        <b> O processo está em conformidade? </b>
                        <FormControlLabel autoFocus value={!confirmProcesso} name='tipoAutorizacao' control={<Checkbox checked={confirmProcesso} />} onChange={() => setConfirmProcesso(!confirmProcesso)} />
                    </Typography>
                    <ButtonLeft
                        title={'Aprovar'}
                        funcao={() => handleApprove('Importação')}
                        disabled={!confirmProcesso}
                        load={load}
                    >
                        <Button color="error" onClick={() => setHabiliteThis(false)}>cancelar</Button>
                    </ButtonLeft>
                </>
            }
        </Card>
    )
}
